/**
 * Danish UI strings – same keys as en.ts, "du"-form.
 *
 * TODO(native review): these translations were written by the implementing engineer, not a native-speaking
 * UX writer. A native speaker should review tone and terminology before the first Danish release
 * (see HANDOFF §2.3 and the copy guide).
 */
export const da: Record<string, string> = {
  // ---- identity
  "status.identity.pre_hire.admin": "Starter snart",
  "status.identity.pre_hire.portal": "Starter {date}",
  "status.identity.pre_hire.help": "Registreret, men ikke startet endnu. Adgang kan gøres klar før startdatoen.",
  "status.identity.active.admin": "Aktiv",
  "status.identity.active.help": "Arbejder her og beholder den adgang, personen har.",
  "status.identity.leave.admin": "På orlov",
  "status.identity.leave.portal": "På orlov",
  "status.identity.leave.help": "Midlertidigt væk. Konti kan være deaktiveret, indtil personen er tilbage.",
  "status.identity.offboarding.admin": "Fratræder",
  "status.identity.offboarding.portal": "Fratræder",
  "status.identity.offboarding.help": "På vej ud. Adgangen er ved at blive fjernet.",
  "status.identity.inactive.admin": "Fratrådt",
  "status.identity.inactive.help": "Arbejder her ikke længere. Der kan ikke tilføjes ny adgang.",

  // ---- request
  "status.request.submitted.admin": "Indsendt",
  "status.request.submitted.portal": "Sendt",
  "status.request.submitted.help": "Registreret og på vej til den første godkender.",
  "status.request.pending_approval.admin": "Afventer godkendelse",
  "status.request.pending_approval.portal": "Venter på {name}",
  "status.request.pending_approval.help": "En eller flere personer skal stadig tage stilling.",
  "status.request.approved.admin": "Godkendt",
  "status.request.approved.portal": "Godkendt – bliver sat op",
  "status.request.approved.help": "Alle beslutninger er truffet. Adgangen bliver sat op nu.",
  "status.request.rejected.admin": "Afvist",
  "status.request.rejected.portal": "Ikke godkendt",
  "status.request.rejected.help": "En godkender sagde nej. Begrundelsen vises.",
  "status.request.completed.admin": "Afsluttet",
  "status.request.completed.portal": "Adgangen er klar",
  "status.request.completed.help": "Adgangen er på plads i systemerne.",
  "status.request.failed.admin": "Fejlet",
  "status.request.failed.portal": "Kunne ikke sættes op",
  "status.request.failed.help": "Opsætningen af adgangen fejlede. En administrator skal se på hvorfor.",
  "status.request.cancelled.admin": "Annulleret",
  "status.request.cancelled.portal": "Annulleret",
  "status.request.cancelled.help": "Trukket tilbage, før der blev truffet en beslutning.",

  // ---- step
  "status.step.waiting.admin": "Ikke startet",
  "status.step.waiting.help": "Et tidligere godkendelsestrin skal afsluttes først.",
  "status.step.pending.admin": "Venter på {name}",
  "status.step.pending.portal": "Venter på dig",
  "status.step.pending.help": "Denne person skal tage stilling nu.",
  "status.step.skipped.admin": "Sprunget over",
  "status.step.skipped.portal": "Sprunget over",
  "status.step.skipped.help": "Ikke nødvendigt, for eksempel fordi godkenderen selv har bedt om adgangen.",
  "status.step.escalated.admin": "Eskaleret",
  "status.step.escalated.portal": "Givet videre til {name}",
  "status.step.escalated.help": "Fristen blev overskredet, så beslutningen er givet videre til en anden.",
  "status.step.approved.admin": "Godkendt",
  "status.step.approved.portal": "Godkendt",
  "status.step.approved.help": "Denne person har godkendt anmodningen.",
  "status.step.rejected.admin": "Afvist",
  "status.step.rejected.portal": "Ikke godkendt",
  "status.step.rejected.help": "Denne person sagde nej. Begrundelsen vises.",

  // ---- account
  "status.account.present.admin": "På plads",
  "status.account.present.help": "Findes i systemet som forventet.",
  "status.account.pending_add.admin": "Bliver oprettet",
  "status.account.pending_add.portal": "Bliver sat op",
  "status.account.pending_add.help": "Platformen har bedt systemet om at oprette den.",
  "status.account.pending_remove.admin": "Bliver fjernet",
  "status.account.pending_remove.portal": "Bliver fjernet",
  "status.account.pending_remove.help": "Platformen har bedt systemet om at fjerne den.",
  "status.account.orphan.admin": "Ingen ejer",
  "status.account.orphan.help": "Ikke knyttet til nogen person. Nogen skal tage ejerskab eller fjerne den.",
  "status.account.external.admin": "Tildelt uden om platformen",
  "status.account.external.help": "Findes i systemet, men er ikke tildelt gennem platformen.",
  "status.account.disabled.admin": "Deaktiveret",
  "status.account.disabled.portal": "Deaktiveret",
  "status.account.disabled.help": "Kontoen findes, men kan ikke bruges.",
  "status.account.locked.admin": "Låst",
  "status.account.locked.portal": "Låst",
  "status.account.locked.help": "For mange mislykkede logins, eller låst af en administrator. Den kan låses op.",

  // ---- syncRun
  "status.syncRun.queued.admin": "I kø",
  "status.syncRun.queued.help": "Starter, når en worker eller agent er ledig.",
  "status.syncRun.running.admin": "Kører",
  "status.syncRun.running.help": "Læser, planlægger eller udfører ændringer nu.",
  "status.syncRun.awaiting_review.admin": "Afventer gennemsyn",
  "status.syncRun.awaiting_review.help": "De planlagte ændringer overstiger en sikkerhedsgrænse. Intet udføres, før nogen godkender eller annullerer.",
  "status.syncRun.held.admin": "Holdt tilbage",
  "status.syncRun.held.help": "Sletninger over grænsen venter på, at en person udfører dem.",
  "status.syncRun.succeeded.admin": "Afsluttet",
  "status.syncRun.succeeded.help": "Alle planlagte ændringer blev udført.",
  "status.syncRun.failed.admin": "Fejlet",
  "status.syncRun.failed.help": "Kørslen stoppede med en fejl. Se trinnet og fejlbeskeden.",
  "status.syncRun.cancelled.admin": "Annulleret",
  "status.syncRun.cancelled.help": "Stoppet af en person, før noget blev udført.",
  "status.syncRun.dry_run.admin": "Testkørsel – intet ændret",
  "status.syncRun.dry_run.help": "Ændringerne blev kun planlagt til gennemsyn.",

  // ---- sod
  "status.sod.blocked.admin": "Må ikke kombineres",
  "status.sod.blocked.portal": "Må ikke kombineres",
  "status.sod.blocked.help": "Denne kombination er forbudt ifølge en politik og kan ikke anmodes om.",
  "status.sod.open.admin": "Åben konflikt",
  "status.sod.open.portal": "Konflikt",
  "status.sod.open.help": "Nogen har begge sider af en politik. Ejeren skal fjerne adgang eller acceptere risikoen.",
  "status.sod.mitigated.admin": "Accepteret indtil {date}",
  "status.sod.mitigated.help": "Risikoen er accepteret med en begrundelse indtil datoen. Derefter åbnes konflikten igen.",
  "status.sod.resolved.admin": "Løst",
  "status.sod.resolved.help": "Ikke længere en konflikt, fordi adgang blev fjernet eller politikken ændret.",

  // ---- certification
  "status.certification.undecided.admin": "Ikke besluttet",
  "status.certification.undecided.portal": "Mangler",
  "status.certification.undecided.help": "Venter på, at den ansvarlige tager stilling.",
  "status.certification.keep.admin": "Behold",
  "status.certification.keep.portal": "Behold",
  "status.certification.keep.help": "Den ansvarlige har bekræftet, at adgangen stadig er nødvendig.",
  "status.certification.revoke.admin": "Fjern",
  "status.certification.revoke.portal": "Fjern",
  "status.certification.revoke.help": "Fjernes, når gennemgangen lukkes – eller med det samme, hvis det er sat op sådan.",
  "status.certification.reassign.admin": "Givet videre",
  "status.certification.reassign.portal": "Givet videre",
  "status.certification.reassign.help": "Sendt til en anden ansvarlig, eller der er foreslået en ejer til kontoen.",

  // ---- remediation
  "status.remediation.pending.admin": "Fjernes",
  "status.remediation.pending.help": "Platformen har bedt systemet om at fjerne adgangen.",
  "status.remediation.done.admin": "Fjernet",
  "status.remediation.done.help": "Adgangen blev fjernet i systemet.",
  "status.remediation.failed.admin": "Fjernelse fejlede",
  "status.remediation.failed.help": "Adgangen kunne ikke fjernes i systemet. En administrator skal handle.",

  // ---- agent
  "status.agent.online.admin": "Online",
  "status.agent.online.help": "Agenten sender livstegn.",
  "status.agent.offline.admin": "Offline",
  "status.agent.offline.help": "Ingen livstegn. Arbejde for agentens systemer er sat på pause.",

  // ---- role
  "status.role.draft.admin": "Kladde",
  "status.role.draft.help": "Under forberedelse. Ingen kan anmode om eller få den endnu.",
  "status.role.published.admin": "Udgivet",
  "status.role.published.help": "I brug. Kan tildeles og – hvis den kan anmodes om – anmodes om.",
  "status.role.retired.admin": "Udfaset",
  "status.role.retired.help": "Tilbydes ikke længere. Tildelinger fra regler fjernes.",

  // ---- assignment
  "status.assignment.active.admin": "Aktiv",
  "status.assignment.active.portal": "Aktiv",
  "status.assignment.active.help": "Adgangen er på plads og i brug.",
  "status.assignment.pending.admin": "Bliver sat op",
  "status.assignment.pending.portal": "Bliver sat op",
  "status.assignment.pending.help": "Tildelt. Konti og medlemskaber bliver oprettet nu.",
  "status.assignment.expiring.admin": "Udløber om {days} dage",
  "status.assignment.expiring.portal": "Udløber om {days} dage",
  "status.assignment.expiring.help": "Tidsbegrænset adgang er ved at udløbe. Den kan forlænges.",
  "status.assignment.expired.admin": "Udløbet",
  "status.assignment.expired.portal": "Udløbet",
  "status.assignment.expired.help": "Slutdatoen er passeret, og adgangen blev fjernet.",
  "status.assignment.revoked.admin": "Tilbagekaldt",
  "status.assignment.revoked.portal": "Fjernet",
  "status.assignment.revoked.help": "Adgangen blev fjernet af en gennemgang, en regel eller en administrator.",

  // ---- job
  "status.job.queued.admin": "I kø",
  "status.job.queued.help": "Venter på en ledig worker.",
  "status.job.running.admin": "Kører",
  "status.job.running.help": "En worker behandler det nu.",
  "status.job.failed.admin": "Fejlet",
  "status.job.failed.help": "Sidste forsøg endte med en fejl. Det prøver selv igen indtil grænsen.",
  "status.job.quarantined.admin": "I karantæne",
  "status.job.quarantined.help": "Fejlede gentagne gange og er sat til side. Det kører ikke igen, før en administrator genoptager det.",
  "status.job.cancelled.admin": "Annulleret",
  "status.job.cancelled.help": "Stoppet, før det blev færdigt.",
  "status.job.succeeded.admin": "Afsluttet",
  "status.job.succeeded.help": "Færdigt uden fejl.",

  // ---- hosting-domæner (tenant, tenantRequest, provisioningJob, release, upgrade, upgradeOutcome, cluster, domain, platformUser)
  "status.tenant.requested.admin": "Anmodet", "status.tenant.requested.help": "Der findes en tilmelding, men intet er oprettet endnu.",
  "status.tenant.provisioning.admin": "Oprettes", "status.tenant.provisioning.help": "Workeren opretter databasen og den første admin-bruger. Tager normalt under et minut.",
  "status.tenant.active.admin": "Aktiv", "status.tenant.active.help": "Brugere kan logge ind; jobs og agenter kører normalt.",
  "status.tenant.suspended.admin": "Suspenderet", "status.tenant.suspended.help": "En operatør har låst brugerne ude. Intet er slettet; genoptag for at lukke dem ind igen.",
  "status.tenant.deprovisioning.admin": "Fjernes", "status.tenant.deprovisioning.help": "Workeren sletter databasen og rollen. Det kan ikke stoppes.",
  "status.tenant.deleted.admin": "Slettet", "status.tenant.deleted.help": "Databasen er væk; kun katalogrækken og revisionssporet er tilbage.",
  "status.tenantRequest.email_verification.admin": "Venter på e-mailbekræftelse", "status.tenantRequest.email_verification.help": "Ansøgeren har ikke klikket på bekræftelseslinket endnu. Intet at gøre før da.",
  "status.tenantRequest.pending.admin": "Venter på afgørelse", "status.tenantRequest.pending.help": "E-mail bekræftet; en operatør skal godkende eller afvise.",
  "status.tenantRequest.approved.admin": "Godkendt – oprettes", "status.tenantRequest.approved.help": "Godkendt; lejeren er ved at blive oprettet.",
  "status.tenantRequest.rejected.admin": "Afvist", "status.tenantRequest.rejected.help": "En operatør sagde nej; begrundelsen er sendt til ansøgeren.",
  "status.tenantRequest.provisioned.admin": "Lejer klar", "status.tenantRequest.provisioned.help": "Lejeren er aktiv, og ejeren er inviteret.",
  "status.provisioningJob.queued.admin": "I kø", "status.provisioningJob.queued.help": "Starter, når tenancy-workeren er ledig.",
  "status.provisioningJob.running.admin": "Kører", "status.provisioningJob.running.help": "Workeren arbejder på det nu.",
  "status.provisioningJob.succeeded.admin": "Fuldført", "status.provisioningJob.succeeded.help": "Afsluttet uden fejl.",
  "status.provisioningJob.failed.admin": "Fejlet", "status.provisioningJob.failed.help": "Stoppede med en fejl og prøver ikke igen af sig selv. Læs fejlen, ret årsagen, og prøv igen.",
  "status.release.draft.admin": "Kladde", "status.release.draft.help": "Endnu ikke synlig for lejere. Udgiv den for at åbne opgraderingsvinduet.",
  "status.release.available.admin": "Udgivet", "status.release.available.help": "Lejere kan opgradere indtil fristen; derefter gennemtvinges opgraderingen.",
  "status.release.closed.admin": "Lukket", "status.release.closed.help": "Vinduet er lukket; lejere, der stadig er bagud, opgraderes automatisk.",
  "status.upgrade.up_to_date.admin": "Opdateret", "status.upgrade.up_to_date.help": "På den nyeste udgivne release.",
  "status.upgrade.available.admin": "Opdatering klar", "status.upgrade.available.help": "En nyere release er udgivet; lejeren bestemmer selv hvornår før fristen.",
  "status.upgrade.scheduled.admin": "Planlagt", "status.upgrade.scheduled.help": "Opgraderingen kører på det valgte tidspunkt.",
  "status.upgrade.running.admin": "Opgraderer", "status.upgrade.running.help": "Snapshot, migreringer og verifikation kører nu.",
  "status.upgrade.failed.admin": "Opgradering fejlet", "status.upgrade.failed.help": "Opgraderingen fejlede, og snapshottet blev gendannet. Kun en hosting-operatør kan prøve igen.",
  "status.upgrade.forced.admin": "Tvunget", "status.upgrade.forced.help": "Fristen udløb uden planlægning, så opgraderingen kører kl. 02:00 i lejerens tidszone.",
  "status.upgrade.blocked.admin": "Kræver mellemliggende release", "status.upgrade.blocked.help": "Lejeren er under releasens minimumsversion; udgiv en mellemliggende release først.",
  "status.upgradeOutcome.succeeded.admin": "Fuldført", "status.upgradeOutcome.succeeded.help": "Migreret og verificeret.",
  "status.upgradeOutcome.failed.admin": "Fejlet", "status.upgradeOutcome.failed.help": "Stoppede med en fejl.",
  "status.upgradeOutcome.rolled_back.admin": "Rullet tilbage", "status.upgradeOutcome.rolled_back.help": "Opgraderingen fejlede, og snapshottet fra før blev gendannet.",
  "status.cluster.unchecked.admin": "Ikke tjekket", "status.cluster.unchecked.help": "Intet sundhedstjek i denne session endnu.",
  "status.cluster.checking.admin": "Tjekker", "status.cluster.checking.help": "Forbinder og kører SELECT 1 (4 s timeout).",
  "status.cluster.ok.admin": "Kan nås", "status.cluster.ok.help": "Admin-forbindelsen virker.",
  "status.cluster.down.admin": "Kan ikke nås", "status.cluster.down.help": "Admin-forbindelsen fejlede; oprettelse på denne cluster fejler, indtil den er tilbage.",
  "status.cluster.full.admin": "Fuld", "status.cluster.full.help": "Har nået sin grænse for lejere.",
  "status.domain.verified.admin": "Verificeret", "status.domain.verified.help": "TXT-posten blev fundet; lejeren kan nås på dette værtsnavn.",
  "status.domain.pending.admin": "Venter på DNS-post", "status.domain.pending.help": "Kunden skal oprette TXT-posten; tryk derefter på Verificér.",
  "status.platformUser.active.admin": "Aktiv", "status.platformUser.active.help": "Kan logge ind.",
  "status.platformUser.must_change_password.admin": "Midlertidig adgangskode", "status.platformUser.must_change_password.help": "Skal skifte adgangskode ved næste login.",
  "status.platformUser.disabled.admin": "Deaktiveret", "status.platformUser.disabled.help": "Kan ikke logge ind; sessioner er afsluttet.",

  // ---- lejeradministration: kampagner, brugere, API-nøgler, kontakter, livscyklus, circuit breaker, agent-watch og relay
  "status.account.deleted.admin": "Fjernet", "status.account.deleted.help": "Kontoen findes ikke længere i systemet.",
  "status.agent.disabled.admin": "Deaktiveret", "status.agent.disabled.help": "Slået fra af en administrator. Den får ikke arbejde, før den aktiveres igen.",
  "status.campaign.draft.admin": "Kladde", "status.campaign.draft.help": "Ikke startet. Reviewerne er ikke blevet spurgt endnu.",
  "status.campaign.active.admin": "Åben", "status.campaign.active.help": "Reviewerne træffer beslutninger. Punkter uden beslutning er uafgjorte.",
  "status.campaign.completed.admin": "Lukket", "status.campaign.completed.help": "Alle beslutninger er truffet og gennemført.",
  "status.campaign.cancelled.admin": "Annulleret", "status.campaign.cancelled.help": "Stoppet før afslutning. Ingen beslutninger blev gennemført.",
  "status.user.active.admin": "Aktiv", "status.user.active.help": "Kan logge ind i administrationen.",
  "status.user.invited.admin": "Inviteret", "status.user.invited.help": "Oprettet, men har ikke sat en adgangskode endnu.",
  "status.user.disabled.admin": "Deaktiveret", "status.user.disabled.help": "Kan ikke logge ind. Aktivér for at lukke brugeren ind igen.",
  "status.apiKey.active.admin": "Aktiv", "status.apiKey.active.help": "Accepteres til API-kald.",
  "status.apiKey.expired.admin": "Udløbet", "status.apiKey.expired.help": "Slutdatoen er passeret. Opret en ny nøgle for at fortsætte.",
  "status.apiKey.revoked.admin": "Tilbagekaldt", "status.apiKey.revoked.help": "Trukket tilbage af en administrator. Kald med den afvises.",
  "status.enabled.enabled.admin": "Aktiveret", "status.enabled.enabled.help": "I brug.",
  "status.enabled.disabled.admin": "Deaktiveret", "status.enabled.disabled.help": "Gemt, men ikke i brug.",
  "status.lifecycle.waiting.admin": "Venter på workeren", "status.lifecycle.waiting.help": "Hændelsen er i kø. Workeren udfører den snart.",
  "status.lifecycle.processed.admin": "Behandlet", "status.lifecycle.processed.help": "Workeren har udført hændelsen.",
  "status.circuit.closed.admin": "Lukket", "status.circuit.closed.help": "Kald går igennem som normalt.",
  "status.circuit.half_open.admin": "Halvåben", "status.circuit.half_open.help": "Tester med få kald efter fejl. Lukker igen, når de lykkes.",
  "status.circuit.open.admin": "Åben", "status.circuit.open.help": "For mange fejl. Kald springes over, indtil pausen er slut.",
  "status.watch.watching.admin": "Overvåger", "status.watch.watching.help": "Modtager ændringer live.",
  "status.watch.starting.admin": "Starter", "status.watch.starting.help": "Forbinder til kilden.",
  "status.watch.catching-up.admin": "Indhenter", "status.watch.catching-up.help": "Afspiller ændringer, der blev misset under afbrydelsen.",
  "status.watch.reconnecting.admin": "Genforbinder", "status.watch.reconnecting.help": "Mistede forbindelsen og prøver igen.",
  "status.watch.paused.admin": "På pause", "status.watch.paused.help": "Stoppet med vilje. Genoptag for at fortsætte.",
  "status.watch.error.admin": "Fejl", "status.watch.error.help": "Overvågningen fejlede. Se den seneste fejl.",
  "status.watch.stopped.admin": "Stoppet", "status.watch.stopped.help": "Overvåger ikke dette domæne.",
  "status.watch.unknown.admin": "Ukendt", "status.watch.unknown.help": "Agenten har ikke rapporteret dette domæne endnu.",
  "status.relay.queued.admin": "I kø", "status.relay.queued.help": "Venter på, at agenten tager den.",
  "status.relay.running.admin": "Kører", "status.relay.running.help": "Agenten udfører kaldet.",
  "status.relay.done.admin": "Udført", "status.relay.done.help": "Agenten har svaret.",
  "status.relay.failed.admin": "Fejlet", "status.relay.failed.help": "Agenten kunne ikke gennemføre kaldet. Se fejlen.",
  "status.upgrade.downloading.admin": "Henter", "status.upgrade.downloading.help": "Agenten henter den nye version.",
  "status.upgrade.installing.admin": "Installerer", "status.upgrade.installing.help": "Agenten installerer den nye version og genstarter.",
  "status.upgradeOutcome.running.admin": "Kører", "status.upgradeOutcome.running.help": "Opgraderingen er i gang.",

  // ---- tones
  "tone.ok": "Fungerer",
  "tone.info": "I gang",
  "tone.warn": "Kræver opmærksomhed",
  "tone.bad": "Blokeret",
  "tone.neutral": "Neutral",

  // ---- risk
  "risk.1": "Lav",
  "risk.2": "Mellem",
  "risk.3": "Høj",
  "risk.4": "Kritisk",
  "risk.label": "{level} risiko",

  // ---- source of access
  "source.rule": "Automatisk",
  "source.request": "Anmodet",
  "source.manual": "Tilføjet af administrator",
  "source.inherited": "Del af rolle",
  "source.import": "Importeret",
  "source.external": "Tildelt uden om platformen",

  // ---- planned change actions
  "action.create": "Opret",
  "action.update": "Opdater",
  "action.link": "Knyt",
  "action.disable": "Deaktiver",
  "action.delete": "Slet",

  // ---- conflicts
  "conflict.prevent": "Må ikke kombineres med {otherSide}, som {holder} har.",
  "conflict.detect": "Er i konflikt med {otherSide}, som {holder} har.",
  "conflict.mitigated": "Er i konflikt med {otherSide}, som {holder} har. Accepteret indtil {until}.",

  // ---- general UI
  "ui.close": "Luk",
  "ui.cancel": "Annuller",
  "ui.back": "Tilbage",
  "ui.save": "Gem",
  "ui.saveDraft": "Gem kladde",
  "ui.saveAndExit": "Gem og afslut",
  "ui.discard": "Kassér",
  "ui.confirm": "Bekræft",
  "ui.details": "Detaljer",
  "ui.search": "Søg",
  "ui.clearSearch": "Ryd søgning",
  "ui.loading": "Indlæser…",
  "ui.copy": "Kopiér",
  "ui.copied": "Kopieret",
  "ui.copyDetails": "Kopiér detaljer",
  "ui.viewOnly": "Kun visning",
  "ui.undo": "Fortryd",
  "ui.moreFilters": "Flere filtre",
  "ui.all": "Alle",
  "ui.openMenu": "Åbn menu",
  "ui.signOut": "Log ud",
  "ui.previousPage": "Forrige side",
  "ui.nextPage": "Næste side",
  "ui.page": "Side {page} af {pages}",
  "ui.total": "{count} i alt",
  "ui.nothingHereYet": "Her er ikke noget endnu",
  "ui.step": "trin {step} af {steps}",
  "ui.steps": "Trin",
  "ui.whatHappened": "Hvad skete der",
  "ui.whatToDo": "Hvad du kan gøre",
  "ui.ref": "ref. {ref}",
  "ui.typeToConfirm": "Skriv {name} for at bekræfte",
  "ui.keep": "Behold",
  "ui.notAvailable.title": "{section} er ikke tilgængelig for dig",
  "ui.notAvailable.body": "Din rolle ({role}) giver ikke adgang til {section}. {how}",
  "ui.notAvailable.home": "Gå til forsiden",
  "ui.notAvailable.copyLink": "Kopiér link til en administrator",
  "ui.group.blocked": "Blokeret",
  "ui.group.attention": "Kræver opmærksomhed",
  "ui.group.later": "Senere",
  "ui.unsavedChanges": "{count} ændringer er ikke gemt",
  "ui.unsavedChange": "1 ændring er ikke gemt",
  "ui.errorsToFix": "{count} fejl skal rettes, før du kan gemme",
  "ui.errorToFix": "1 fejl skal rettes, før du kan gemme",
  "ui.nothingChangedYet": "Der er ikke ændret noget endnu",
  "ui.applyChanges": "Udfør {count} ændringer",
  "ui.cancelRun": "Annuller kørsel",
  "ui.howGotThis": "Sådan fik {name} adgangen",
  "ui.cause": "Årsag",
  "ui.environment.production": "Produktion",
  "ui.environment.sandbox": "Sandkasse",
  "ui.viewingReadOnly": "Viser {tenant} · kun læsning",
  "ui.theme": "Tema",
  "ui.theme.light": "Lyst",
  "ui.theme.dark": "Mørkt",
  "ui.theme.system": "Følg systemet",
  "ui.leavePage": "Du har ændringer, der ikke er gemt. Vil du forlade siden uden at gemme?",
  "ui.clear": "Ryd",
  "ui.change": "Skift",
  "ui.noMatches": "Ingen match",
  "ui.removeItem": "Fjern {name}",
  "ui.nothingSelected": "Intet valgt",
  "ui.searchNothing": "Intet matcher “{q}”",
  "ui.accountMenu": "Kontomenu for {name}",
  "ui.profile": "Profil",
  "ui.language": "Sprog",
  "ui.pager.showing": "Viser {from}–{to} af {total}",

  // ---- login-startside (home realm discovery)
  "ui.chooser.intro": "Skriv din arbejdsmail for at logge ind.",
  "ui.chooser.email": "Arbejdsmail",
  "ui.chooser.continue": "Fortsæt",
  "ui.chooser.pickIntro": "{email} hører til mere end én organisation. Vælg hvor du vil logge ind.",
  "ui.chooser.notFound": "Vi kunne ikke finde en organisation for {domain}. Tjek adressen, eller skriv din organisations kortnavn.",
  "ui.chooser.manualIntro": "Skriv din organisations kortnavn for at fortsætte.",
  "ui.chooser.organisation": "Organisation",
  "ui.chooser.unknownOrganisation": "Ukendt organisation",
  "ui.chooser.useManual": "Log ind med organisationsnavn",
  "ui.chooser.useEmail": "Log ind med e-mail i stedet",
  "ui.chooser.back": "Brug en anden e-mail",
  "ui.chooser.signup": "Anmod om en ny organisation",
  "ui.chooser.hosting": "Hosting-administration",
};
